import Header from "./components/header/Header";
import React, {useEffect, useState} from "react";
import Sidebar from "./components/Sidebar";
import {UpdateHeaderContext} from "./context/update_header";

const Layout = ({children, sidebarClickHandler, userInfo}) => {
  const [isOpen, setIsOpen] = useState(false);

  const [updateNotifications, setUpdateNotifications] = useState(Date.now)

  useEffect(() => {
    const handleResize = () => {
      setIsOpen(window.innerWidth >= 950); // Check screen width and set isOpen accordingly
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <UpdateHeaderContext.Provider value={{
      updateNotifications: updateNotifications,
      setUpdateNotifications: setUpdateNotifications,
    }}>
      <div className="flex h-screen w-full flex-row bg-app-canvas text-app-text">
        <Sidebar
          onClick={sidebarClickHandler}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          userInfo={userInfo}
          className={`${isOpen ? 'w-96' : 'w-0'} z-100 flex h-screen`} // Adjust width here
        />
        {/*absolute sm:static md:static lg:static*/}
        <div className="flex w-full flex-col overflow-x-auto bg-app-canvas">
          <Header
            isOpen={isOpen}
            onClick={sidebarClickHandler}
            setIsOpen={setIsOpen}
            userInfo={userInfo}
            className="sticky top-0 flex w-full flex-row py-4"
          />
          <main className="h-screen overflow-y-auto bg-app-canvas px-2 py-3 text-app-text">{children}</main>
        </div>
      </div>
    </UpdateHeaderContext.Provider>
  )
};

export default Layout;
